import { FacetsBodyParser } from './models';

const facetsBodyParser = ({ filters, pageId, resultsSubTags }: FacetsBodyParser) => {
  const aggregations = filters.reduce((acc, filter) => {
    acc[`${filter}_facet`] = {
      terms: {
        field: `${filter}.keyword`,
        size: 100,
        min_doc_count: 1,
      },
    };

    return acc;
  }, {} as Record<string, any>);

  const mustFilters: any[] = [];

  if (resultsSubTags && resultsSubTags.length > 0) {
    const tagNames = resultsSubTags.map((tag) => tag.name);
    mustFilters.push({
      terms: {
        'articleSubTags.name.keyword': tagNames,
      },
    });
  }

  if (pageId) {
    mustFilters.push({
      term: {
        landingPageId: pageId,
      },
    });
  }

  return {
    size: 0,
    aggs: aggregations,
    ...(mustFilters.length > 0 && {
      query: {
        bool: {
          must: mustFilters,
        },
      },
    }),
  };
};

export default facetsBodyParser;
